{
    "name": "@dbp-toolkit/common",
    "homepage": "https://github.com/digital-blueprint/toolkit/tree/main/packages/common",
    "version": "0.3.17",
    "type": "module",
    "main": "src/index.js",
    "license": "LGPL-2.1-or-later",
    "repository": {
        "type": "git",
        "url": "https://github.com/digital-blueprint/toolkit.git",
        "directory": "packages/common"
    },
    "dbp": {
        "assets": [
            {
                "srcPackage": "@dbp-toolkit/common",
                "src": "assets/icons",
                "dest": "."
            }
        ]
    },
    "devDependencies": {
        "@dbp-toolkit/dev-utils": "^0.1.2",
        "@web/test-runner": "^0.20.2",
        "@web/test-runner-playwright": "^0.11.1",
        "chai": "^6.0.0",
        "eslint": "^9.1.0",
        "eslint-plugin-jsdoc": "^61.0.0",
        "globals": "^16.0.0",
        "i18next-cli": "^1.5.4",
        "mocha": "^11.0.0",
        "playwright": "^1.34.0",
        "playwright-core": "^1.20.2",
        "prettier": "^3.0.0",
        "rolldown": "^1.0.0-beta.44",
        "rollup-plugin-serve": "^3.0.0",
        "typescript": "^5.2.2"
    },
    "scripts": {
        "i18next:fix": "i18next-cli extract",
        "i18next": "i18next-cli extract --ci --dry-run",
        "fix": "npm run eslint:fix && npm run prettier:fix && npm run i18next:fix",
        "check": "npm run eslint && npm run prettier && npm run i18next",
        "eslint:fix": "eslint \"**/*.{js,ts}\" --fix --cache",
        "eslint": "eslint \"**/*.{js,ts}\" --cache",
        "prettier:fix": "prettier \"**/*.{js,json,ts,md,yaml,yml}\" --write --cache",
        "prettier": "prettier \"**/*.{js,json,ts,md,yaml,yml}\" --check --cache",
        "clean": "rm dist/*",
        "build": "rolldown -c rollup.config.js",
        "build-test": "rolldown -c rollup.config.js --environment BUILD:test",
        "test": "npm run build-test && web-test-runner",
        "watch": "rolldown -c rollup.config.js --watch",
        "tsc": "tsc -p jsconfig.json"
    },
    "dependencies": {
        "@open-wc/dedupe-mixin": "^2.0.1",
        "@open-wc/scoped-elements": "^3.0.5",
        "dialog-polyfill": "^0.5.6",
        "i18next": "^23.0.0 || ^24.0.0 || ^25.0.0",
        "lit": "^3.0.0"
    }
}
